import React from 'react';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
import ProductActions from './ProductActions';
import { useGetProductsHandler } from '../dataHandlers/getProductsHandler';
import { currencyFormatter } from '../../../utils/currencyFormat';
import CustomPagination from '../../../components/customPagination';
import { getUOMOptions } from '../../../api/codelist/codeListsSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const ProductsTable = ({ searchQuery = {}, handlePaginationChange }) => {
  const uomOptions = useSelector(getUOMOptions);
  const { products: p } = useTranslatedMessages();
  const col = p.table?.columns ?? {};
  const { products, totalDocuments, isLoading } = useGetProductsHandler({ searchQuery });

  const columns = [
    { field: 'name', headerName: col.item_name ?? 'Item Name', flex: 2 },
    {
      field: 'unit_of_measure',
      headerName: col.unit_of_measure ?? 'Unit of Measure',
      flex: 1,
      renderCell: (params) => {
        return uomOptions.find((uom) => uom.code === params.value)?.name || params.value;
      },
    },
    {
      field: 'unit_price',
      headerName: col.unit_price ?? 'Unit Price',
      flex: 1,
      align: 'right',
      renderCell: (params) => currencyFormatter().format(params.value),
    },
    {
      field: 'classified_tax_category',
      headerName: col.tax_category ?? 'Tax Category',
      flex: 1,
      renderCell: (params) => {
        const tc = params?.value;
        return tc?.id;
      },
    },
    {
      field: 'tax_category_rate',
      headerName: col.tax_rate ?? 'Tax Rate',
      flex: 1,
      renderCell: (params) => {
        const tc = params?.row.classified_tax_category;
        return `${tc?.percent ?? 0}%`;
      },
    },
    {
      field: 'actions',
      headerName: col.actions ?? 'Actions',
      flex: 0.5,
      sortable: false,
      renderCell: (params) => <ProductActions product={params.row} />,
    },
  ];

  return (
    <Box>
      <DataGrid
        loading={isLoading}
        rows={products}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default ProductsTable;
